module.exports = __webpack_public_path__ + "img/arrow.d40fd77b.svg";